import { ChangeDetectorRef, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CampaignDTO } from '../../../core/models/campaignDTO.model';
import { CampaignService } from '../../../core/services/campaign.service';
import { BrandingConfig } from '../../../core/models/brandingConfig.model';
import { BrandingConfigService } from '../../../core/services/branding-config.service';
import { MatDialog, MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { Observable } from 'rxjs';
import { NgxDropzoneChangeEvent } from 'ngx-dropzone';

@Component({
    selector: 'kt-dialog-config-branding',
    templateUrl: './dialog-config-branding.component.html',
    styleUrls: ['./dialog-config-branding.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DialogConfigBrandingComponent implements OnInit {

    isSavingConfig: boolean;
    isLoadingCampaigns: boolean;
    isLoadingBrandingConfig: boolean;
    brandingConfigId: number;
    brandingForm: FormGroup;
    campaigns: CampaignDTO[];
    headerLogo: File[] = [];
    headerLogoImagePath: string;
    loadingHeaderLogo: boolean;
    loginLogo: File[] = [];
    loginLogoImagePath: string;
    loadingLoginLogo: boolean;
    loginBackground: File[] = [];
    loginBackgroundImagePath: string;
    loadingLoginBackground: boolean;
    registerBackground: File[] = [];
    registerBackgroundImagePath: string;
    loadingRegisterBackground: boolean;
    disabledCampaignsDropdown: boolean;

    constructor(
        private brandingService: BrandingConfigService,
        private campaignService: CampaignService,
        private fb: FormBuilder,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA)
        public data: number,
        public dialogRef: MatDialogRef<DialogConfigBrandingComponent>,
        private cdr: ChangeDetectorRef) { }

    ngOnInit() {
        this.initForm();
        this.loadCampaigns();
        this.loadBrandingConfig();
    }
    loadCampaigns() {
        this.isLoadingCampaigns = true;
        this.campaignService.getCampaigns().subscribe(res => {
            this.campaigns = res;
            if (res.length > 0 && !this.data) {
                this.brandingForm.patchValue({ campaignId: res[0].id });
            }
            this.isLoadingCampaigns = false;
            this.cdr.detectChanges();
        });
    }
    loadBrandingConfig() {
        this.isLoadingBrandingConfig = true;
        const brandingConfig: Observable<BrandingConfig> = this.data === null ? this.brandingService.getCurrentBrandingConfig() : this.brandingService.getBrandingConfig(this.data);
        brandingConfig.subscribe(res => {
            this.brandingForm.patchValue({
                primaryColor: res.primaryColor,
                secondaryColor: res.secondaryColor,
            });
            if (this.data) {
                this.brandingConfigId = res.id;
                this.brandingForm.patchValue({ campaignId: res.campaignId });
                this.headerLogoImagePath = res.headerLogo;
                this.loginLogoImagePath = res.loginLogo;
                this.loginBackgroundImagePath = res.loginBackground;
                this.registerBackgroundImagePath = res.registerBackground;
            }
            this.isLoadingBrandingConfig = false;
            this.cdr.detectChanges();
        })
    }
    initForm() {
        this.brandingForm = this.fb.group({
            campaignId: [{ value: null, disabled: this.data !== null }, Validators.required],
            primaryColor: ['', Validators.required],
            secondaryColor: ['', Validators.required],
        });
    }
    isControlHasError(controlName: string, validationType: string): boolean {
        const control = this.brandingForm.controls[controlName];
        if (!control) {
            return false;
        }

        return control.hasError(validationType) && (control.dirty || control.touched);
    }
    createBrandingConfig() {
        const controls = this.brandingForm.controls;
        if (this.brandingForm.invalid) {
            Object.keys(controls).forEach(controlName => {
                controls[controlName].markAsTouched();
            }
            );
            return;
        }
        let saveConfig: Observable<any>;
        this.isSavingConfig = true;
        if (this.data) {
            const editedBrandingConfig = new BrandingConfig();
            editedBrandingConfig.id = this.brandingConfigId;
            editedBrandingConfig.campaignId = controls['campaignId'].value;
            editedBrandingConfig.primaryColor = controls['primaryColor'].value;
            editedBrandingConfig.secondaryColor = controls['secondaryColor'].value;
            editedBrandingConfig.loginLogo = this.loginLogoImagePath;
            editedBrandingConfig.headerLogo = this.headerLogoImagePath;
            editedBrandingConfig.loginBackground = this.loginBackgroundImagePath;
            editedBrandingConfig.registerBackground = this.registerBackgroundImagePath;
            saveConfig = this.brandingService.editBrandingConfig(editedBrandingConfig);
        }
        else {
            saveConfig = this.brandingService.createBrandingConfig(controls['campaignId'].value,controls['primaryColor'].value,controls['secondaryColor'].value)
        }
        saveConfig.subscribe((res) => {
            this.brandingService.uploadBrandingConfigImages(res.id, this.headerLogo[0], this.loginLogo[0], this.loginBackground[0], this.registerBackground[0]).subscribe(res => {
                this.isSavingConfig = false;
                this.dialogRef.close(true);
                this.cdr.detectChanges();
            });
        });
    }
    headerLogoSelect($event: NgxDropzoneChangeEvent) {
        this.headerLogo.splice(0, 1);
        this.headerLogo.push(...$event.addedFiles);
    }
    headerLogoFileRemove() {
        this.headerLogo = [];
        this.headerLogoImagePath = null;
    }
    loginLogoSelect($event: NgxDropzoneChangeEvent) {
        this.loginLogo.splice(0, 1);
        this.loginLogo.push(...$event.addedFiles);
    }
    loginLogoFileRemove() {
        this.loginLogo = [];
        this.loginLogoImagePath = null;
    }
    loginBackgroundSelect($event: NgxDropzoneChangeEvent) {
        this.loginBackground.splice(0, 1);
        this.loginBackground.push(...$event.addedFiles);
    }
    loginBackgroundRemove() {
        this.loginBackground = [];
        this.loginBackgroundImagePath = null;
    }
    registerBackgroundSelect($event: NgxDropzoneChangeEvent) {
        this.registerBackground.splice(0, 1);
        this.registerBackground.push(...$event.addedFiles);
    }
    registerBackgroundRemove() {
        this.registerBackground = [];
        this.registerBackgroundImagePath = null;
    }
}
